import axiosInstance from "../utils/axiosConfig";

const fetchPapeleta = async (idMotorista, dataInicial, dataFinal) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest2/";
  const apiUrl = `${baseUrl}INT_PAPELETA_WSMARCACOES`;

  try {
    const response = await axiosInstance.get(apiUrl, {
      params: {
        id_motorista: idMotorista,
        data_inicial: dataInicial,
        data_final: dataFinal,
      },
      timeout: 10000, // Aumentar timeout para 10 segundos
    });

    return response.data; // Retorna os dados da resposta
  } catch (error) {
    console.error("Erro ao fazer a requisição:", error);

    // Lança o erro com a mensagem apropriada
    throw new Error("Houve um problema ao buscar os dados da API.");
  }
};

export { fetchPapeleta };
